// i18n area 'backups' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.el-GR.meta.json.
import type { enUS } from './backups'

export const elGR: typeof enUS = {
  ckpt: {
    contents: 'Δέχεται',
    contentsHint:
      'Τι μπορεί να προσγειωθεί εδώ. Τα «Checkpoints» είναι η διαμόρφωση της συστάδας, τα «Αντίγραφα δεδομένων» είναι των VM: οι δύο αναγνώσεις συντίθενται, ένας προορισμός μπορεί να δεχτεί και τα δύο.',
    content: { checkpoints: 'Checkpoints', backups: 'Αντίγραφα δεδομένων' },
    destinationsTitle: 'Προορισμοί backup',
    checkpointsTitle: 'Checkpoint',
    restoreTitle: 'Επαναφορά',
    addDestination: 'Προσθήκη προορισμού',
    addDestinationTitle: 'Προσθήκη προορισμού backup',
    editDestinationTitle: 'Επεξεργασία προορισμού',
    storage: 'Χώρος αποθήκευσης',
    storageHint:
      'Ένας dir-like χώρος αποθήκευσης (dir/NFS/CIFS/CephFS) — τα τεχνουργήματα είναι κανονικά αρχεία κάτω από το namespace της πλατφόρμας.',
    schedule: 'Προγραμματισμός',
    scheduleNone: 'Μόνο χειροκίνητα',
    scheduleHourly: 'Κάθε ώρα',
    scheduleDaily: 'Ημερήσιος',
    scheduleWeekly: 'Εβδομαδιαίος',
    scheduleHour: 'Ώρα',
    scheduleWeekday: 'Ημέρα',
    scheduleHint:
      'Τα προγραμματισμένα checkpoint δεν έχουν χειριστή να πληκτρολογήσει το masterpass: τα μυστικά της αποθήκης κλειδιών πακετάρονται ως placeholder.',
    retention: 'Διατήρηση',
    retentionHint:
      'Πόσα προγραμματισμένα checkpoint διατηρούνται — ο σαρωτής αφαιρεί τα παλαιότερα πέρα από το πλήθος. Τα χειροκίνητα και τα προ-επαναφοράς checkpoint δεν αφαιρούνται ποτέ.',
    paused: 'Σε παύση',
    pausedHint:
      'Το blackout του χειριστή: όσο διαρκεί η παύση, σε αυτόν τον προορισμό τίποτα δεν προγραμματίζεται και τίποτα δεν κλαδεύεται — πολιτικές δεδομένων και checkpoint εξίσου. Οι εκτελέσεις σε εξέλιξη δεν αγγίζονται ποτέ.',
    orphanRuns: '{n} ορφανές εκτελέσεις',
    orphanRunsHint:
      'Προγραμματισμένες εκτελέσεις από policies που δεν υπάρχουν πια σε αυτόν τον προορισμό: καμία retention δεν τις διέπει — ποτέ μετρημένες, ποτέ κλαδεμένες — και μόνο ένα χέρι τις διαγράφει. Ο φακός «backups» του tvirt diagnose κατονομάζει τις αφαιρεμένες policies.',
    rescan: 'Επανυιοθέτηση artifacts',
    rescanTitle: 'Επανυιοθέτηση των artifacts του {name}',
    rescanHint:
      'Ανακατασκευάζει τον κατάλογο αντιγράφων (VM/CT/App) από τα manifest των artifacts στον προορισμό. Οι υπάρχουσες γραμμές δεν αγγίζονται ποτέ· τα αντίγραφα άγνωστων πολιτικών μένουν ορφανά (δεν κλαδεύονται ποτέ αυτόματα). Η κίνηση μετά από επαναφορά bootstrap.',
    masterpassDrWarning:
      'Σενάριο καταστροφής: οι δίσκοι LUKS επιστρέφουν ΜΟΝΟ από checkpoint ΜΕ masterpass. Τα προγραμματισμένα checkpoint πακετάρουν placeholders — παίρνετε περιοδικά χειροκίνητο checkpoint με masterpass.',
    policy: {
      title: 'Πολιτικές backup δεδομένων',
      hint: 'Ονομασμένες πολιτικές: ποια αντικείμενα (kind, ετικέτες, scope), κάθε πότε, πότε μπορεί να ξεκινήσει μια εκτέλεση, και πόσα αντίγραφα κρατιούνται. Η χειρονομία της κατάταξης μένει στον ιδιοκτήτη του αντικειμένου: οι ετικέτες ανατίθενται στο δικό του scope.',
      add: 'Προσθήκη πολιτικής',
      column: 'Πολιτικές δεδομένων',
      name: 'Όνομα',
      nameHint:
        'Ετικέτα της policy, μοναδική μέσα στον προορισμό. Οι εκτελέσεις ακολουθούν το σταθερό id της policy: η μετονομασία είναι δωρεάν· η διαγραφή της ορφανεύει τις εκτελέσεις της (δεν μετρώνται ούτε κλαδεύονται πια).',
      kindLocked: 'Η οικογένεια αντικειμένων μιας υπάρχουσας policy δεν αλλάζει: δημιουργήστε νέα policy.',
      kindLabel: 'Αντικείμενα',
      kind: { vm: 'Εικονικές μηχανές', ct: 'Κοντέινερ', app: 'Εφαρμογές' },
      tags: 'Επιλογέας ετικετών',
      tagsHint:
        'Ζεύγη tag=τιμή, χωρισμένα με κόμματα, σε AND. Κενές ετικέτες και scope δεν επιλέγουν τίποτα — ποτέ «τα πάντα».',
      scopes: 'Scope',
      scopesHint: 'Διαδρομές scope (υποδέντρα), χωρισμένες με κόμματα, σε OR μεταξύ τους.',
      windowStart: 'Παράθυρο από',
      windowEnd: 'Παράθυρο έως',
      windowHint:
        'Παράθυρο εκτέλεσης (HH:MM, τοπική ώρα· αρχή πέρα από το τέλος δρασκελίζει τα μεσάνυχτα). Κυβερνά μόνο την ΕΚΚΙΝΗΣΗ: μια εκτέλεση που το ξεπερνά δεν σκοτώνεται ποτέ.',
      mode: 'Λειτουργία',
      modeHint:
        'Το αυξητικό καβαλά την οικογένεια σειρών· μια σπασμένη σειρά υποβαθμίζεται σε full, ειπωμένο στο ημερολόγιο.',
      modeFull: 'Full',
      modeIncremental: 'Αυξητικό',
      requireQuiesce: 'Απαίτηση quiesce (guest agent)',
      paused: 'Πολιτική σε παύση',
      retentionNone: 'Κράτα τα πάντα',
      retentionCount: 'Πλήθος',
      retentionGfs: 'Δαχτυλίδια GFS',
      gfs: { keepLast: 'Τελευταία', daily: 'Ημερήσια', weekly: 'Εβδομαδιαία', monthly: 'Μηνιαία', yearly: 'Ετήσια' },
      gfsHint:
        'Για κάθε δαχτυλίδι κρατιέται το νεότερο backup καθεμιάς από τις τελευταίες N περιόδους. Ένα κρατημένο backup κρατά ζωντανή ολόκληρη την αλυσίδα του — ποτέ βάση με ορφανά.',
      lastRun: 'Τελευταία εκτέλεση',
      neverRan: 'δεν εκτελέστηκε ποτέ'
    },
    lastCheckpoint: 'Τελευταίο checkpoint',
    neverRun: 'Δεν δημιουργήθηκε ποτέ',
    createNow: 'Δημιουργία checkpoint',
    createNowTitle: 'Δημιουργία checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Προστατεύει τις μυστικές τιμές της αποθήκης κλειδιών (argon2id → AES-256-GCM, ανά τιμή). Δεν αποθηκεύεται ποτέ: φυλάξτε το — χωρίς αυτό, μια επαναφορά παράγει placeholder αντί για τα πραγματικά μυστικά.',
    masterpassEmptyHint: 'Αφήστε το κενό για να πακεταριστούν ρητά placeholder αντί για τα μυστικά.',
    createStarted: 'Checkpoint σε εξέλιξη…',
    destinationInUseError: 'Ο προορισμός «{name}» περιέχει ακόμη checkpoint — διαγράψτε τα πρώτα.',
    origin: 'Προέλευση',
    originManual: 'χειροκίνητη',
    originSchedule: 'προγραμματισμένη',
    originPreRestore: 'προ-επαναφοράς',
    originPreChange: 'προ αλλαγής',
    preChangeRetention: 'Checkpoints προ αλλαγής',
    preChangeRetentionHint:
      'Κενό = ανενεργό. Η πρώτη εγγραφή ρύθμισης μετά από περίοδο ησυχίας παγώνει εδώ την προηγούμενη κατάσταση (προέλευση «προ αλλαγής»)· τα νεότερα διατηρούνται έως το πλήθος — δική της, κλαδεύσιμη διατήρηση.',
    diffTitle: 'Προεπισκόπηση αλλαγών',
    diffFailed: 'Η προεπισκόπηση απέτυχε',
    diffRetry: 'Δοκιμή ξανά',
    diffCounts: '{changed} προς αλλαγή · {missing} προς δημιουργία · {extra} πλεονάζοντα · {equal} πανομοιότυπα',
    diffChanged: 'αλλάζει',
    diffMissing: 'θα δημιουργηθεί',
    diffExtra: 'θα διαγραφεί',
    diffJsonb: 'αναφορές jsonb μη επαληθεύσιμες πριν την εφαρμογή',
    diffSecret: 'σφραγισμένα πεδία, μη συγκρίσιμα',
    diffMore: 'άλλα {n}…',
    diffNeeded: 'Η εκκίνηση οπλίζει όταν η προεπισκόπηση αντικατοπτρίζει την επιλογή.',
    phase: 'Κατάσταση',
    phaseRunning: 'σε εξέλιξη',
    phaseComplete: 'ολοκληρώθηκε',
    phaseError: 'σφάλμα',
    secrets: 'Μυστικά',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholder',
    size: 'Μέγεθος',
    created: 'Δημιουργήθηκε',
    destination: 'Προορισμός',
    download: 'Λήψη .tvbk',
    deleteCheckpoint: 'Διαγραφή checkpoint',
    noCheckpoints: 'Κανένα checkpoint — δημιουργήστε ένα από έναν προορισμό.',

    // Round #156 (τυπικό παράθυρο διαλόγου): η πλήρης επιφάνεια ανάγνωσης της
    // εγγραφής αρχειοθήκης — γραμμές λεπτομερειών για τα πεδία που η λίστα δεν έδειχνε ποτέ.
    families: 'Οικογένειες',
    generation: 'Γενιά',
    completedAt: 'Ολοκληρώθηκε στις',
    errorDetail: 'Λεπτομέρεια σφάλματος',
    manifest: 'Manifest',
    restoreHint:
      'Μεταφορτώστε ένα τεχνούργημα .tvbk: η εξερεύνηση δείχνει τι περιέχει, έπειτα επιλέγετε τι θα επαναφέρετε και πώς.',
    uploadFile: 'Μεταφόρτωση αρχείου .tvbk',
    uploading: 'Μεταφόρτωση…',
    uploadFailed: 'Δεν ήταν δυνατό το άνοιγμα του τεχνουργήματος',
    explorerTitle: 'Περιεχόμενο του checkpoint',
    checkpointFrom: 'Checkpoint της συστοιχίας {cluster}, δημιουργήθηκε στις {when} ({origin}, γενιά {generation})',
    otherCluster:
      'Αυτό το checkpoint προέρχεται από ΑΛΛΗ συστοιχία ({cluster}) — η επαναφορά μεταξύ συστοιχιών έρχεται σε μελλοντικό round.',
    encrypted: 'κρυπτογραφημένο',
    objectsCount: '{n} αντικείμενα',
    mode: 'Λειτουργία',
    modeMerge: 'Merge — συμφιλιώνει: upsert των επιλεγμένων, δεν διαγράφει τίποτα',
    modeOverwrite:
      'Overwrite — κερδίζει το checkpoint: μια πλήρως επιλεγμένη οικογένεια αντικαθίσταται ολόκληρη (οι τρέχουσες γραμμές που λείπουν από το checkpoint πεθαίνουν)',
    restoreMasterpassHint:
      'Το masterpass με το οποίο δημιουργήθηκε το checkpoint. Χωρίς αυτό, τα κρυπτογραφημένα μυστικά επαναφέρονται ως ρητά placeholder.',
    checkMasterpass: 'Έλεγχος',
    masterpassOk: 'Σωστό masterpass',
    masterpassWrong: 'Λάθος masterpass',
    parachuteDestination: 'Προορισμός-αλεξίπτωτο',
    parachuteHint: 'Πριν αγγίξει οποιαδήποτε γραμμή, η εργασία δημιουργεί εδώ ένα αυτόματο checkpoint προ-επαναφοράς.',
    summaryTitle: 'Τι θα συμβεί',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'ολόκληρη η οικογένεια',
    summaryObjects: '{n} επιλεγμένα αντικείμενα',
    confirmHint:
      'Πληκτρολογήστε το όνομα της συστοιχίας ({name}) για επιβεβαίωση — μια επαναφορά ξαναγράφει τη δηλωμένη διαμόρφωση.',
    confirmField: 'Όνομα της συστοιχίας',
    startRestore: 'Επαναφορά',
    restoreRunning: 'Επαναφορά σε εξέλιξη…',
    restoreDone: 'Η επαναφορά ολοκληρώθηκε — οι reconciler συγκλίνουν στη νέα δήλωση.',
    restoreFailed: 'Η επαναφορά απέτυχε',
    discard: 'Απόρριψη',
    selectionEmpty: 'Επιλέξτε τουλάχιστον μία οικογένεια ή ένα αντικείμενο.'
  },

  backup: {
    intro: {
      title: 'Αντίγραφα ασφαλείας δεδομένων VM και κοντέινερ',
      subtitle: 'Τα δομικά στοιχεία που χρησιμοποιεί το εξωτερικό λογισμικό αντιγράφων ασφαλείας',
      whatItIs:
        'Το TVirt εκθέτει τέσσερις πρωτογενείς λειτουργίες: στιγμιότυπα quiesced, παρακολούθηση αλλαγών ανά δίσκο, εξαγωγή NBD μόνο για ανάγνωση και εξαγωγή της διαμόρφωσης. Τις οδηγούν τα Veeam, Bacula, Acronis και τα συναφή.',
      whatItIsNot:
        'Το TVirt δεν είναι προϊόν αντιγράφων ασφαλείας: δεν προγραμματίζει τίποτα, δεν εφαρμόζει διατήρηση και δεν φυλάσσει κανένα αρχείο των δεδομένων σας. Η διατήρηση, οι κατάλογοι και οι πολιτικές επαναφοράς παραμένουν στο λογισμικό που ήδη χρησιμοποιείτε.'
    },
    cbt: {
      title: 'Παρακολούθηση αλλαγών',
      colVm: 'VM',
      colDisk: 'Δίσκος',
      colState: 'Κατάσταση',
      colBitmaps: 'Bitmaps',
      colObservedAt: 'Παρατηρήθηκε',
      colChangeId: 'Change ID',
      colMechanic: 'Μηχανισμός',
      stateActive: 'Ενεργό',
      stateInactive: 'Ανενεργό',
      stateInconsistent: 'Ασυνεπές — το επόμενο αντίγραφο πρέπει να είναι πλήρες',
      stateBroken: 'Αλυσίδα κομμένη — απενεργοποιήστε και ενεργοποιήστε ως νέα αλυσίδα',
      stateSnapshots: 'Πάντα ενεργό — delta μεταξύ στιγμιοτύπων',
      stateUnavailable: 'Μη διαθέσιμο σε αυτόν τον δίσκο',
      mechanic: {
        'qcow2-bitmap': 'Bitmap qcow2',
        'rbd-snapdiff': 'Diff στιγμιοτύπων Ceph',
        'lvm-thin-delta': 'Delta thin pool',
        none: 'Κανένας'
      },
      empty:
        'Κανένας δίσκος VM. Η παρακολούθηση διαβάζεται ανά δίσκο: ενεργοποιήστε την σε δίσκο qcow2 ή πάρτε στιγμιότυπα σε rbd/SAN.',
      chainBroken: 'Αλυσίδα κομμένη',
      chainBrokenText:
        'Κόπηκε από {reason}: {bitmaps}. Απενεργοποιήστε το bitmap (η αλυσίδα χάθηκε, το επόμενο αντίγραφο είναι πλήρες) και ενεργοποιήστε το ως νέα αλυσίδα.',
      lineages: 'Εποχές',
      epochFrozen: 'παγωμένη στο στιγμιότυπο {snapshot}',
      epochLost: 'χαμένη ({cause})',
      epochRecording: 'καταγράφει στην κεφαλή',
      milestones: 'Ορόσημα (στιγμιότυπα)',
      enable: 'Ενεργοποίηση παρακολούθησης',
      disable: 'Απενεργοποίηση',
      reset: 'Επαναφορά',
      changedAreas: 'Αλλαγμένες περιοχές',
      denied: 'Δεν έχετε το δικαίωμα σε αυτή τη VM',
      enableTitle: 'Ενεργοποίηση παρακολούθησης αλλαγών',
      disableTitle: 'Απενεργοποίηση παρακολούθησης αλλαγών',
      resetTitle: 'Επαναφορά του bitmap',
      areasTitle: 'Αλλαγμένες περιοχές',
      bitmapName: 'Όνομα bitmap',
      bitmapNameHint: 'Δικό σας όνομα: τα tvirt- και tvbk- ανήκουν στην πλατφόρμα',
      granularity: 'Κοκκομετρία (bytes)',
      granularityHint: 'Δύναμη του δύο· προεπιλογή 65536',
      bitmap: 'Bitmap',
      disableHint: 'Αφαιρεί το bitmap και όλο το ιστορικό εποχών του: το επόμενο αντίγραφο πρέπει να είναι πλήρες.',
      resetHint: 'Αδειάζει το bitmap — νέα βάση: ένα change ID παλαιότερο της επαναφοράς δεν συντίθεται πλέον.',
      areasFrom: 'Από στιγμιότυπο',
      areasTo: 'Έως στιγμιότυπο',
      areasRun: 'Υπολογισμός',
      areasResult: '{count} αλλαγμένες περιοχές, {bytes}',
      areasEmpty: 'Καμία αλλαγμένη περιοχή μεταξύ των δύο στιγμιοτύπων',
      areasZero: 'μηδενικά',
      areasMore: 'εμφανίζονται οι πρώτες {shown} από {count}',
      submit: 'Επιβεβαίωση',
      error: 'Η ενέργεια παρακολούθησης απέτυχε'
    },
    exports: {
      title: 'Ανοιχτές εξαγωγές NBD',
      colVm: 'VM',
      colDisk: 'Δίσκος',
      colSnapshot: 'Στιγμιότυπο',
      colBitmap: 'Bitmap',
      colPhase: 'Φάση',
      colNode: 'Κόμβος',
      colEndpoint: 'Endpoint',
      colExpires: 'Λήγει',
      colCreated: 'Άνοιξε',
      colError: 'Σφάλμα',
      phase: {
        preparing: 'Προετοιμασία',
        ready: 'Έτοιμη',
        closed: 'Κλειστή',
        error: 'Απέτυχε'
      },
      expiresIn: 'σε {minutes} λεπτά',
      expired: 'έληξε',
      empty: 'Κανένα export. Μια συνεδρία ανάγνωσης σερβίρει έναν δίσκο σε ένα snapshot σε έναν NBD client· μια συνεδρία εγγραφής γεμίζει έναν παρθένο δίσκο μιας σταματημένης VM. Και οι δύο πεθαίνουν στη λήξη.',
      endpointHint: 'TLS με την CA του cluster· το όνομα εξαγωγής είναι το εισιτήριο — πεθαίνει με τη συνεδρία',
      closeDenied: 'Δεν έχετε το δικαίωμα να κλείνετε εξαγωγές αυτής της VM',
      open: 'Άνοιγμα εξαγωγής NBD',
      openTitle: 'Άνοιγμα εξαγωγής NBD',
      openDisk: 'Δίσκος',
      openBitmap: 'Bitmap (προαιρετικό)',
      openBitmapHint:
        'Δημοσιεύει την εποχή αυτού του bitmap που πάγωσε σε αυτό το στιγμιότυπο ως meta-context των αλλαγμένων extents (μόνο δίσκοι qcow2)',
      openTtl: 'Διάρκεια (λεπτά)',
      openSubmit: 'Άνοιγμα',
      openError: 'Η εξαγωγή δεν μπόρεσε να ανοίξει',
      colMode: 'Λειτουργία',
      mode: {
        read: 'Ανάγνωση',
        write: 'Εγγραφή'
      },
      caCertificate: 'CA του cluster',
      caCopy: 'Αντιγραφή PEM',
      caDownload: 'Λήψη ca-cert.pem',
      caHint: 'Γράψτε το PEM στο ca-cert.pem σε έναν ιδιωτικό φάκελο και συνδεθείτε με nbds://…?tls-certificates=<φάκελος> (nbdcopy, nbdinfo) ή --object tls-creds-x509,dir=<φάκελος>,endpoint=client (qemu-img)',
      caAbsent: 'Η συνεδρία δεν φέρει CA (χωρίς PKI)',
      openWrite: 'Άνοιγμα export εγγραφής',
      openWriteTitle: 'Άνοιγμα export εγγραφής',
      openWriteIntro: 'Ο δίσκος πρέπει να είναι παρθένος: γεννημένος κενός, ποτέ γραμμένος, χωρίς snapshot· η VM σταματημένη. Η επαναφορά ΓΕΜΙΖΕΙ τον δίσκο, δεν τον επισκευάζει. Όσο η συνεδρία είναι ανοιχτή, η VM δεν εκκινεί, δεν παίρνει snapshot, δεν κλωνοποιείται και ο δίσκος δεν μετακινείται.',
      openWriteSubmit: 'Άνοιγμα',
      openWriteError: 'Το export εγγραφής δεν άνοιξε',
      openWriteDenied: 'Σας λείπει το vm.restore.data σε αυτή τη VM',
      openWriteStopped: 'Σταματήστε τη VM για να ανοίξετε export εγγραφής',
      fromDescription: 'Δημιουργία VM από description',
      fromDescriptionTitle: 'Δημιουργία VM από description',
      fromDescriptionIntro: 'Το description του export-vm-meta επιστρέφει ως σταματημένη VM με κενούς δίσκους της περιγραφόμενης γεωμετρίας — έτοιμη για τα export εγγραφής, δίσκο προς δίσκο. Τα bytes δεν περνούν από εδώ: τα μεταφέρει το restore-disk (CLI) ή ο NBD client του προϊόντος backup.',
      fromDescriptionDoc: 'Description (JSON)',
      fromDescriptionDocHint: 'Επικολλήστε το έγγραφο του export-vm-meta ή επιλέξτε το αρχείο',
      fromDescriptionFile: 'Επιλογή αρχείου…',
      fromDescriptionInvalid: 'Το κείμενο δεν είναι έγγραφο JSON',
      fromDescriptionName: 'Όνομα της νέας VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Το αρχικό σας scope',
      fromDescriptionStorage: 'Storage των δίσκων',
      fromDescriptionStorageHint: 'Κάθε δίσκος γεννιέται εδώ, στην προεπιλεγμένη μορφή του storage',
      fromDescriptionMetadataStorage: 'Storage των μεταδεδομένων',
      fromDescriptionSameAsStorage: 'Το ίδιο με τους δίσκους',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Χωρίς bridge ούτε δίκτυο η VM γεννιέται χωρίς κάρτες',
      fromDescriptionNetwork: 'Λογικό δίκτυο (fabric/δίκτυο)',
      fromDescriptionSubmit: 'Δημιουργία',
      fromDescriptionError: 'Η VM δεν δημιουργήθηκε',
      fromDescriptionDone: 'VM δημιουργήθηκε: {name}',
      fromDescriptionOpen: 'Άνοιγμα της VM',
      fromDescriptionDenied: 'Σας λείπει το vm.create',
      fromDescriptionStillRunning: 'Η δημιουργία συνεχίζεται: συνεχίζουμε να περιμένουμε'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Αντίγραφα δεδομένων των VM',
      titleOnVm: 'Αντίγραφα δεδομένων',
      empty:
        'Κανένα αντίγραφο. Ένα αντίγραφο μεταφέρει τους δίσκους, το varstore UEFI και την κατάσταση του vTPM σε έναν προορισμό, και επιβιώνει της VM.',
      colVm: 'VM',
      colCreated: 'Λήφθηκε',
      colPhase: 'Έκβαση',
      colDestination: 'Προορισμός',
      colContains: 'Περιεχόμενο',
      colSize: 'Μέγεθος',
      colOrigin: 'Προέλευση',
      colMode: 'Τύπος',
      retentionChip: 'Διατήρηση',
      retentionHint:
        'Η διατήρηση του προορισμού μπορεί να διαγράψει αυτό το αντίγραφο χωρίς να ρωτήσει: γεννήθηκε από χρονοπρογραμματισμό. Τα χειροκίνητα αντίγραφα δεν σαρώνονται ποτέ.',
      policyRemoved: 'Policy αφαιρέθηκε: {name}',
      policyRemovedHint:
        'Η policy που προγραμμάτισε αυτό το backup δεν υπάρχει πια: καμία retention δεν το διέπει (δεν κλαδεύεται ποτέ αυτόματα) — διαγράψτε το με το χέρι όταν δεν χρειάζεται πια.',
      phase: {
        running: 'Σε εξέλιξη',
        complete: 'Ολοκληρώθηκε',
        error: 'Απέτυχε'
      },
      origin: {
        manual: 'Χειροκίνητο',
        schedule: 'Προγραμματισμένο'
      },
      mode: {
        full: 'Πλήρες',
        incremental: 'Σταδιακό'
      },
      contains: {
        disks: 'Δίσκοι',
        varstore: 'Varstore UEFI',
        vtpm: 'Κατάσταση vTPM',
        snapshots: 'Στιγμιότυπα'
      },
      vmState: {
        stopped: 'VM σβηστή',
        running: 'VM σε λειτουργία (θερμό)'
      },
      artifactClass: { metadata: 'Μεταδεδομένα', data: 'Δεδομένα', secret: 'Μυστικό' },
      detail: {
        tabOverview: 'Σύνοψη',
        tabArtefact: 'Τεχνούργημα',
        id: 'Αναγνωριστικό',
        scope: 'Εμβέλεια',
        vmState: 'Κατάσταση VM κατά την αντιγραφή',
        pointInTime: 'Στιγμή των δεδομένων',
        completedAt: 'Ολοκληρώθηκε στις',
        node: 'Κόμβος που αντέγραψε',
        error: 'Σφάλμα',
        path: 'Φάκελος στον αποθηκευτικό χώρο',
        checksum: 'sha256 του manifest',
        secretsExposed: 'Ευαίσθητο υλικό σε καθαρή μορφή',
        secretsExposedYes: 'Ναι — ο προορισμός δεν κρυπτογραφεί',
        secretsExposedNo: 'Όχι',
        baseBackup: 'Βασικό αντίγραφο',
        tabManifest: 'Manifest',
        manifestHint:
          'Το ευανάγνωστο ευρετήριο του τεχνουργήματος: ένα αρχείο ανά γραμμή με το sha256 του. Ο φάκελος επαληθεύεται και χωρίς TVirt — αρκούν τα qemu-img, tar και jq.',
        manifestEmpty: 'Το manifest δεν απαριθμεί αρχεία.',
        manifestError: 'Το manifest δεν είναι αναγνώσιμο',
        colEntry: 'Αρχείο',
        colClass: 'Κλάση',
        colSha: 'sha256'
      },
      create: {
        action: 'Αντιγραφή τώρα',
        title: 'Αντιγραφή τώρα',
        submit: 'Έναρξη αντιγραφής',
        destination: 'Προορισμός',
        destinationHint: 'Μόνο οι προορισμοί που δέχονται αντίγραφα.',
        noDestinations: 'Κανένας προορισμός δεν δέχεται αντίγραφα: δημιουργήστε έναν στο Σύστημα → Checkpoints.',
        contentsHint:
          'Ταξιδεύουν όλοι οι δίσκοι, το varstore UEFI και η κατάσταση του vTPM. Τα δύο τελευταία είναι το ζητούμενο: ένας σφραγισμένος guest πρέπει να ξεκινήσει ξανά.',
        error: 'Η αντιγραφή δεν ξεκίνησε',
        stillRunning: 'Η αντιγραφή είναι ακόμη σε εξέλιξη — συνεχίζεται ακόμη κι αν κλείσετε.',
        vmRunning:
          'Η VM είναι {phase}: το αντίγραφο θέλει σταθερή VM — σβηστή για την ψυχρή αντιγραφή, σε λειτουργία για τη θερμή.'
      },
      restore: {
        action: 'Επαναφορά',
        title: 'Επαναφορά',
        intro:
          'Η επαναφορά είναι μη αναστρέψιμη. Επιλέξτε πού επιστρέφουν τα δεδομένα: σε νέα μηχανή ή πάνω στην αρχική.',
        modeNewVm: 'Επαναφορά σε ΝΕΑ VM',
        modeNewVmHint:
          'Δεν αγγίζει τίποτα από όσα υπάρχουν — είναι η επιλογή με την οποία επαληθεύεται ένα αντίγραφο. Νέο αναγνωριστικό και ολοκαίνουργιες MAC.',
        modeOver: 'Αντικατάσταση της αρχικής VM',
        modeOverHint: 'Καταστρέφει τα τρέχοντα δεδομένα της VM στόχου, χωρίς επιστροφή. Η VM πρέπει να είναι σβηστή.',
        newName: 'Όνομα της νέας VM',
        newNameHint: 'Πρέπει να είναι ελεύθερο στην εμβέλεια προορισμού.',
        storage: 'Αποθηκευτικός χώρος των δίσκων',
        storageHint:
          'Υποχρεωτικό: το manifest καταγράφει το μέγεθος και τη μορφή ενός δίσκου, ποτέ τον χώρο στον οποίο βρισκόταν.',
        metadataStorage: 'Αποθηκευτικός χώρος για varstore και vTPM',
        metadataStorageHint: 'Πού προσγειώνονται η ταυτότητα UEFI και η κατάσταση του vTPM.',
        sameAsStorage: 'Ο ίδιος με τους δίσκους',
        bridge: 'Bridge του host',
        bridgeHint:
          'Κάθε καταγεγραμμένη κάρτα επιστρέφει σε αυτό το bridge με νέα MAC. Αφημένο κενό, η VM γεννιέται χωρίς κάρτες — η ασφαλέστερη προεπιλογή.',
        overwriteTitle: 'Πρόκειται να αντικαταστήσετε αυτή τη VM',
        overwriteName: 'Όνομα',
        overwriteId: 'Αναγνωριστικό',
        overwriteDisks: 'Δίσκοι που θα ξαναγραφούν',
        overwriteNoDisks: 'Κανένας δίσκος.',
        overwriteKeeps:
          'Μένουν ανέπαφα το αναγνωριστικό, το όνομα, η εμβέλεια, οι κάρτες δικτύου και οι MAC: ένα αντίγραφο είναι τα ΔΕΔΟΜΕΝΑ, η διαμόρφωση είναι το checkpoint.',
        confirmField: 'Όνομα της VM',
        confirmHint: 'Πληκτρολογήστε {name} για επιβεβαίωση.',
        targetLoading: 'Ανάγνωση της VM στόχου…',
        targetRunning:
          "Η VM στόχος είναι {phase}: η επαναφορά ξαναγράφει τα byte κάτω από τον guest, γι' αυτό τη θέλει σβηστή.",
        targetGone: 'Η αρχική VM δεν είναι πλέον αναγνώσιμη: απομένει η επαναφορά σε νέα VM.',
        onlyComplete: 'Το αντίγραφο είναι {phase}: μόνο ένα ολοκληρωμένο αντίγραφο μπορεί να επαναφέρει.',
        submitNewVm: 'Επαναφορά στη νέα VM',
        submitOver: 'Αντικατάσταση',
        error: 'Η επαναφορά δεν ξεκίνησε',
        stillRunning: 'Η επαναφορά είναι ακόμη σε εξέλιξη — η αντιγραφή ολόκληρων δίσκων θέλει χρόνο.'
      }
    },
    guest: {
      title: {
        ct: 'Αντίγραφα δεδομένων των containers',
        app: 'Αντίγραφα δεδομένων των App'
      },
      tabTitle: 'Αντίγραφα',
      empty:
        'Κανένα αντίγραφο. Ένα αντίγραφο μεταφέρει τα μόνιμα δεδομένα σε έναν προορισμό και επιζεί του αντικειμένου του.',
      colSubject: {
        ct: 'Container',
        app: 'App'
      },
      colCreated: 'Ελήφθη',
      colPhase: 'Έκβαση',
      colDestination: 'Προορισμός',
      colContains: 'Περιεχόμενο',
      colSize: 'Μέγεθος',
      colOrigin: 'Προέλευση',
      policyRemoved: 'Policy αφαιρέθηκε: {name}',
      policyRemovedHint:
        'Η policy που προγραμμάτισε αυτό το backup δεν υπάρχει πια: καμία retention δεν το διέπει (δεν κλαδεύεται ποτέ αυτόματα) — διαγράψτε το με το χέρι όταν δεν χρειάζεται πια.',
      phase: {
        running: 'Σε εξέλιξη',
        complete: 'Ολοκληρώθηκε',
        error: 'Απέτυχε'
      },
      origin: {
        manual: 'Χειροκίνητο',
        schedule: 'Προγραμματισμένο'
      },
      state: {
        stopped: 'Αντικείμενο σταματημένο',
        running: 'Αντικείμενο σε λειτουργία (παγωμένο)'
      },
      contains: {
        rootfs: 'Δέντρο rootfs',
        config: 'Διαμόρφωση',
        volumes: 'Μόνιμοι τόμοι',
        root: 'Μόνιμη root'
      },
      artifactClass: {
        metadata: 'Μεταδεδομένα',
        data: 'Δεδομένα',
        secret: 'Μυστικό'
      },
      create: {
        action: 'Αντίγραφο τώρα',
        title: 'Νέο αντίγραφο',
        submit: 'Έναρξη αντιγράφου',
        error: 'Το αντίγραφο δεν ξεκίνησε',
        destination: 'Προορισμός',
        destinationHint: 'Μόνο προορισμοί που δέχονται αντίγραφα δεδομένων.',
        noDestinations:
          'Κανένας προορισμός δεν δέχεται αντίγραφα δεδομένων: προσθέστε «Αντίγραφα δεδομένων» σε έναν προορισμό.',
        hint: {
          ct: 'Ταξιδεύει ολόκληρο το δέντρο rootfs, πιστά (αριθμητικοί ιδιοκτήτες, xattrs, ACL), συν τη δηλωμένη διαμόρφωση στο manifest. Ένα container σε λειτουργία ΠΑΓΩΝΕΙ για όλη τη συσκευασία: crash-consistent αντίγραφο, δηλωμένο.',
          app: 'Ταξιδεύουν ΜΟΝΟ οι μόνιμοι τόμοι (και η μόνιμη root), συν η διαμόρφωση στο manifest. Τα εφήμερα εξαιρούνται με επικύρωση και το manifest τα κατονομάζει· οι τιμές env που δηλώθηκαν μυστικές δεν ταξιδεύουν.'
        },
        stillRunning: 'Αντίγραφο ακόμη σε εξέλιξη — η συσκευασία ολόκληρων δέντρων παίρνει χρόνο.'
      },
      detail: {
        tabOverview: 'Επισκόπηση',
        tabManifest: 'Manifest',
        id: 'Αναγνωριστικό',
        scope: 'Εμβέλεια',
        state: 'Κατάσταση κατά την αντιγραφή',
        pointInTime: 'Δεδομένα κατά τη στιγμή',
        completedAt: 'Ολοκληρώθηκε',
        node: 'Κόμβος που αντέγραψε',
        error: 'Σφάλμα',
        path: 'Φάκελος στον αποθηκευτικό χώρο',
        checksum: 'sha256 του manifest',
        manifestHint:
          'Ο δείκτης του artefact: μία εγγραφή ανά αρχείο με το sha256 του — χωρίς τα hashes, το «το αντίγραφο υπάρχει» είναι πράξη πίστης.',
        manifestError: 'Το manifest δεν διαβάζεται',
        manifestEmpty: 'Κανένα artefact στο manifest.',
        colEntry: 'Αρχείο',
        colClass: 'Κλάση',
        colSha: 'sha256',
        excluded: 'Εξαιρέθηκε με επικύρωση (δεν ταξιδεύει)',
        secretKeys: 'Παραλειφθέντα μυστικά κλειδιά env (#307) — ξαναεισάγετέ τα μετά από επαναφορά'
      },
      restore: {
        action: 'Επαναφορά',
        title: 'Επαναφορά',
        submit: 'Επαναφορά',
        error: 'Η επαναφορά δεν ξεκίνησε',
        stillRunning: 'Επαναφορά ακόμη σε εξέλιξη — η εξαγωγή ολόκληρων δέντρων παίρνει χρόνο.',
        onlyComplete: 'Το αντίγραφο είναι {phase}: μόνο ένα ολοκληρωμένο αντίγραφο μπορεί να επαναφέρει.',
        asNew: {
          ct: 'Σε ΝΕΟ container — δεν καταστρέφει τίποτα: η χειρονομία με την οποία ελέγχεται ένα αντίγραφο',
          app: 'Σε ΝΕΟ App — δεν καταστρέφει τίποτα: η χειρονομία με την οποία ελέγχεται ένα αντίγραφο'
        },
        over: {
          ct: 'ΠΑΝΩ στο container προέλευσης — αντικαθίσταται ολόκληρο το δέντρο rootfs',
          app: 'ΠΑΝΩ στο App προέλευσης — αντικαθίσταται το περιεχόμενο κάθε μόνιμου τόμου'
        },
        name: 'Όνομα του νέου αντικειμένου',
        storage: 'Αποθηκευτικός χώρος',
        storageHint: 'Πού προσγειώνονται τα επαναφερμένα δεδομένα — το manifest δεν καταγράφει ποτέ το χαμένο pool.',
        storageDeclared: 'Οι αποθηκευτικοί χώροι που δηλώνονται στο manifest',
        bridge: 'Bridge του host',
        bridgeHint:
          'Κάθε καταγεγραμμένη κάρτα επιστρέφει σε αυτό το bridge με φρέσκια MAC. Κενό = γεννιέται αποσυνδεδεμένο, η ασφαλέστερη προεπιλογή.',
        node: 'Κόμβος',
        nodeHint:
          'Το μέλος στο οποίο ξαναγεννιέται το App: ο κόμβος είναι ταυτότητα cluster και δεν έρχεται ποτέ από το manifest.',
        secretKeysWarning:
          'Οι τιμές env που δηλώθηκαν μυστικές δεν ταξιδεύουν στο αντίγραφο: το ξαναγεννημένο αντίγραφο τις θέλει ξαναεισηγμένες (το log της εργασίας κατονομάζει τα κλειδιά).',
        overInventory: 'Πρόκειται να αντικαταστήσετε αυτό το αντικείμενο',
        confirmType: 'Πληκτρολογήστε {name} για επιβεβαίωση',
        targetGone: 'Το αντικείμενο προέλευσης δεν διαβάζεται πια: μένει η επαναφορά ως νέο.',
        targetLoading: 'Ανάγνωση του αντικειμένου-στόχου…',
        targetRunning:
          'Το αντικείμενο-στόχος λειτουργεί: η επαναφορά αντικαθιστά τα bytes κάτω από τον guest και το θέλει σταματημένο.'
      }
    }
  }
}
